import type { ApiRecipe } from "avvir";
import type { AvvirEvent } from "type_aliases";

export type ProjectRecipesUpdatedEvent = AvvirEvent<typeof PROJECT_RECIPES_UPDATED, { recipes: ApiRecipe[] }>

const projectRecipesUpdated = ( recipes: ApiRecipe[] ): ProjectRecipesUpdatedEvent => ({
  type: PROJECT_RECIPES_UPDATED,
  payload: {
    recipes
  }
});

export const PROJECT_RECIPES_UPDATED = "project_recipes_updated";

export default projectRecipesUpdated;
